import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { theme } from '../../../styles/theme';
import { Card } from '../../common/Card';

const AddCauseCardContainer = styled(Card)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${theme.spacing.lg};
  border: 2px dashed ${theme.colors.softGray};
  cursor: pointer;
  text-decoration: none;
  color: ${theme.colors.deepNavy};
  transition: background-color 0.3s;

  &:hover {
    background-color: ${theme.colors.iceBlue};
  }
`;

const AddIcon = styled.span`
  font-size: 24px;
  margin-right: ${theme.spacing.sm};
`;

const AddText = styled.span`
  font-size: ${theme.typography.fontSizes.large};
  font-weight: bold;
`;

export const AddCauseCard = () => {
  return (
    <Link to="/causes" style={{ textDecoration: 'none' }}>
      <AddCauseCardContainer>
        <AddIcon>+</AddIcon>
        <AddText>Add New Cause</AddText>
      </AddCauseCardContainer>
    </Link>
  );
};
